/* eslint-disable */
import api from '../../../api/scripts'
import router from '../../../router'


const actions = {
    async loadCircuits({commit, state}) {
        const response = await api.getScriptCircuits(state.activeWorkout)
        const circuits = response.data
        commit('setCircuit', circuits.map(circuit => {
            return {
                ...circuit,
                confirmed: true,
                moves: circuit.items && circuit.items.length > 0 ? circuit.items.reduce((acc, item, index) => {
                    const accList = []
                    if (index === 1) {
                        if (acc.type === 'round'){
                            accList.concat(acc.items.filter(item => item.type === 'move'))
                        }
                        else if (acc.type === 'move') {
                            accList.push(acc)
                        }
                    }
                    if (item.type === 'round'){
                        accList.concat(item.items.filter(item => item.type === 'move'))
                    }
                    else if (item.type === 'move') {
                        accList.push(item)
                    }
                    return accList
                }) : []
            }
        }))
    },
    getCircuits({commit, dispatch}){
        dispatch('loadCircuits')
        dispatch('getAutoCue')
        commit('clearSelectedMoves')
    },
    addEmptyCircuit({commit}){    
        commit('addEmptyCircuit')  
    },
    async updateCircuit({commit, state, dispatch}, payload){
        commit('updateCircuit', payload)
        const finalPayload = {
            type: payload.type,
            work: payload.type === 'timer' ? payload.work : 0,
            rest: payload.type === 'timer' ? payload.rest : 0,
            activity: state.activeWorkout,
            items: [],
        }
        await api.createCircuit(finalPayload)
        dispatch('getCircuits')
    },
    async syncCircuits({state, dispatch}) {
        for (let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            await api.updateCircuit(circuit)
        }
        dispatch('getCircuits')
    },
    async syncCircuitsWithoutClearingSelectedMoves({state, dispatch}) {
        for (let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            await api.updateCircuit(circuit)
        }
        dispatch('loadCircuits')
    },
    removeCircuit({commit}, id){
        commit('removeCircuit', id)
    },
    updateItem({commit, dispatch}, payload){
        commit('updateItem', payload)
        commit('updateItemOrdering')
        dispatch('syncCircuits')
    },
    updateItemNoSync({commit}, payload){
        commit('updateItem', payload)
    },    
    updateMove({commit, dispatch}, payload){
        commit('updateMove', payload)
        //dispatch('syncCircuits')
    },
    removeItem({commit, dispatch}, payload){
        commit('removeItem', payload)
        dispatch('syncCircuits')
    },
    removeMove({commit, dispatch}, payload){
        commit('removeMove', payload)
        //dispatch('syncCircuits')
    },
    
    addEmptyMoveToCurrentCircuit({commit}) {
        commit('addEmptyMoveToCurrentCircuit')
    },
    addEmptyInstructionToCurrentCircuit({commit}) {
        commit('addEmptyInstructionToCurrentCircuit')
    },

    addMoveAboveCurrentCircuit({commit}) {
        commit('addEmptyMoveAboveToCurrentCircuit')
    },

    addMoveBelowCurrentCircuit({commit}) {
        commit('addEmptyMoveBelowToCurrentCircuit')
    },

    addInstructionAboveCurrentCircuit({commit}) {
        commit('addEmptyInstructionAboveToCurrentCircuit')
    },

    addInstructionBelowCurrentCircuit({commit}) {
        commit('addEmptyInstructionBelowToCurrentCircuit')
    },

    deleteSelectedItems({ state, commit, dispatch }) {
        state.selectedMoves.forEach(async selectedMove => {
            commit('removeItem', selectedMove)
            commit('removeMove', selectedMove)
            await api.deleteScriptItem(selectedMove)
        })
        commit('clearSelectedMoves')
        commit('updateItemOrdering')
        //dispatch('getCircuits')
    },

    async deleteSelectedCircuits({state, commit, dispatch}, activity) {
        for(let i=0;i<state.selectedCircuits.length;i++) {
            const selectedCircuit = state.selectedCircuits[i]
            await api.deleteScriptCircuit(activity, selectedCircuit)
        }
        commit('updateItemOrdering')
        commit('clearSelectedCircuits')
        dispatch('getCircuits')
    },
    
    async deleteSelectedItem({state, dispatch}, itemId) {
        await api.deleteScriptItem(itemId)
        commit('updateItemOrdering')
        dispatch('getCircuits')
    },

    moveSelectedItemsUp({commit, dispatch}) {
        commit('moveItemsUp')
        commit('updateItemOrdering')
        dispatch('updateItemOrdering')
        commit('setRender', false)
        commit('setRender', true)        
    },

    moveSelectedItemsDown({commit, dispatch}) {
        commit('moveItemsDown')
        commit('updateItemOrdering')
        dispatch('updateItemOrdering')
        commit('setRender', false)
        commit('setRender', true)
    },

    moveSelectedItemsFirst({commit, dispatch}) {
        commit('moveItemsFirst')
        commit('updateItemOrdering')
        dispatch('updateItemOrdering')
    },

    moveSelectedItemsLast({commit, dispatch}) {
        commit('moveItemsLast')
        commit('updateItemOrdering')
        dispatch('updateItemOrdering')
    },

    createRound({commit, dispatch}){
        commit('createRound')
        commit('updateItemOrdering')
        dispatch('syncCircuits')
    },

    ungroupRound({commit, dispatch}, id){
        commit('ungroupRound', id)
        commit('updateItemOrdering')
        dispatch('updateItemOrdering')
        dispatch('syncCircuits')
    },

    updateItemOrdering({getters}) {
        const itemOrderingList = getters['itemOrdering']
        itemOrderingList.forEach(async itemOrdering => {
            await api.updateScriptItem(itemOrdering.id, {order: itemOrdering.order})
        })
    },

    updateCircuitList({commit, dispatch}, payload){
        commit('updateCircuitList', payload)
        commit('updateItemOrdering')
        dispatch('updateItemOrdering')
    },
    pushSelectedCircuit({commit}, circuitId){
        commit('pushSelectedCircuit', circuitId)
    },
    popSelectedCircuit({commit}, circuitId) {
        commit('popSelectedCircuit', circuitId)
    },
    toggleAutoCue({commit, state}) {
        commit('setAutoCue', !state.autoCue)
    },
    setAutoCue({commit}, payload) {
        commit('setAutoCue', payload)
    },
    async getAutoCue({commit, state}){
        const response = await api.getScriptCircuitsAutoCue(state.activeWorkout)
        commit('setCueItems', response.data.flat())
    },
    async getAutoCueWithRests({commit}, id){
        const response = await api.getScriptCircuitsAutoCueWithRests(id)
        const flattenedWithOrder = []
        let activeOrder = 1
        for (let i=0;i<response.data.length;i++) {
            const circuit = response.data[i]
            for (let j=0;j<circuit.length;j++) {
                const item = {
                    ...circuit[j]
                }
                item.order = activeOrder
                flattenedWithOrder.push(item)
                if (item.interval_type === 'work') {
                    activeOrder += 1
                }
            }
        }
        commit('setCueWithRestItems', flattenedWithOrder)
    },
    async getAutoCueWithRestsAndCircuitDetails({commit}, id){
        const response = await api.getScriptCircuitsAutoCueWithRestsAndCircuitDetails(id)
        commit('setCueWithRestItemsWithCircuit', response.data)
    },
    openActiveWorkout({ state }){
        router.push(`/auto-cue/${state.activeWorkout}`)
    },
}
export default actions
